

import { isConcierge, get } from './lib/config'
import { Helmet } from 'react-helmet'
import * as React from 'react'

export const Title = () => {
  const isFromConcierge = isConcierge || window.location.hostname.indexOf('concierge') !== -1
  const centreName = get('name') || ''
  return (
      <Helmet>
        <title>
          { isFromConcierge ? `Concierge - ${centreName}` : `Tourist - ${centreName}` }
        </title>
      </Helmet>
  )
}



// WEBPACK FOOTER //
// ./src/Title.tsx